import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-text-confirmation',
  templateUrl: './text-confirmation.component.html'
})
export class TextConfirmationComponent {

  userRepeat: string;

  constructor(
    public dialogRef: MatDialogRef<TextConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { infoText: string; wordToRepeat: string }
  ) { }

  confirm(): void {
    if (this.isEqual(this.data.wordToRepeat, this.userRepeat)) {
      this.dialogRef.close(true);
    }
  }

  isEqual(a: string, b: string): boolean {
    return a != null && b != null && a.toLocaleLowerCase() === b.toLocaleLowerCase();
  }

}
